export function useLoading(state, props) {
    var isLoading = state.isLoading, setLoading = state.setLoading, isReadonly = state.isReadonly, isDisabled = state.isDisabled;
    var loading = props.loading;
    function show() {
        return Boolean((loading || isLoading()) &&
            !isDisabled());
    }
    function set(loading) {
        setLoading(loading);
    }
    function toggle() {
        setLoading(!loading);
    }
    return {
        show: show(),
        set: set,
        toggle: toggle,
    };
}
